import { useEffect } from "react";

import { ScanningStatus } from "../models/benchly.models";
import { useCitationStore } from "../store/CitationStore";

export interface UseFuzzyScanningResult {
  isSearching: boolean;
  progress: number;
  statusMessage: string;
  hasError: boolean;
  isComplete: boolean;
}

/**
 * Hook to perform fuzzy search on non-certified citations
 * This runs automatically when the component mounts
 */
export const useFuzzyScanning = (): UseFuzzyScanningResult => {
  const { fuzzyStatus, fuzzyProgress, fuzzyStatusMessage, startFuzzyScanning } =
    useCitationStore();

  // Start fuzzy scanning on mount
  useEffect(() => {
    console.log("[useFuzzyScanning] Starting fuzzy scan...");
    startFuzzyScanning();
  }, [startFuzzyScanning]);

  const isSearching = fuzzyStatus === ScanningStatus.FuzzySearching;
  const hasError = fuzzyStatus === ScanningStatus.Error;
  const isComplete = fuzzyStatus === ScanningStatus.Complete;

  return {
    isSearching,
    progress: fuzzyProgress,
    statusMessage: fuzzyStatusMessage,
    hasError,
    isComplete,
  };
};
